import { Construction } from "lucide-react";
import { NAV_MODULES } from "@laundrypro/shared";
import { Card, EmptyState, PageHeader } from "../components/ui";
import { useBranding } from "../context/BrandingContext";

/**
 * Stands in for a module whose implementation phase has not landed.
 *
 * It says plainly that the module is not built. The alternative — a screen of
 * empty tables and zeroed statistics — looks like a working feature with no data
 * in it, which is a lie told by omission.
 */
export function ModulePlaceholder({
  moduleKey,
  phaseAr,
  phaseEn,
}: {
  moduleKey: string;
  phaseAr: string;
  phaseEn: string;
}) {
  const { language } = useBranding();
  const ar = language === "ar";
  const module = NAV_MODULES.find((m) => m.key === moduleKey);
  const title = module ? (ar ? module.labelAr : module.labelEn) : moduleKey;

  return (
    <div className="space-y-4">
      <PageHeader title={title} />
      <Card padding="none">
        <EmptyState
          icon={<Construction className="size-6" />}
          title={ar ? "لم تُبنَ هذه الوحدة بعد" : "This module isn't built yet"}
          description={
            ar
              ? `مجدولة في ${phaseAr}. صلاحيات الوصول موجودة ومطبَّقة على الخادم بالفعل، لكن الواجهة والبيانات لم تُنفَّذ.`
              : `Scheduled for ${phaseEn}. Its access permissions already exist and are enforced server-side; the interface and data are not implemented.`
          }
        />
      </Card>
    </div>
  );
}
